/**
 * settingsApi.js
 * --------------
 * API client for Education > Lectures > Settings submodule.
 * Connects directly to FastAPI backend with zero mock data.
 */
import api from '../../../../api/client'

export const DEFAULT_LECTURE_SETTINGS = {
  populateStudents: 'S', // 'A': All Students, 'S': Students with selected Subjects
  repeatLectures: 'N', // 'Y': Yes, 'N': No
  smsSchedule: 'M', // 'M': Manual, 'A': Automatic
  smsType: 'C', // 'C': Combined, 'S': Separate
  smsTo: {
    students: true,
    parents: true,
    mother: false,
    faculty: true,
  },
  whatsAppTo: {
    students: true,
    parents: true,
    mother: false,
    faculty: true,
  },
  swipeTimeBefore: 15, // minutes before lecture starts
  swipeTimeAfter: 30, // minutes after lecture starts
}

export async function getLectureSettings() {
  try {
    const { data } = await api.get('/lectures/settings')
    if (data?.settings) {
      return { ...DEFAULT_LECTURE_SETTINGS, ...data.settings }
    }
  } catch (e) {
    console.error('Failed to fetch lecture settings from backend', e)
  }
  return { ...DEFAULT_LECTURE_SETTINGS }
}

export async function saveLectureSettings(settings) {
  try {
    const { data } = await api.put('/lectures/settings', settings)
    return { success: true, settings: data?.settings || settings }
  } catch (e) {
    console.error('Failed to save lecture settings', e)
    return { success: false, error: e?.response?.data?.detail || e.message }
  }
}

export async function resetLectureSettings() {
  try {
    const { data } = await api.post('/lectures/settings/reset')
    return { success: true, settings: data?.settings || { ...DEFAULT_LECTURE_SETTINGS } }
  } catch (e) {
    console.error('Failed to reset lecture settings', e)
    return { success: false, error: e?.response?.data?.detail || e.message }
  }
}
